var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.job)?_c('span',[_c('jobable-claim-reference',{attrs:{"job":_vm.job}}),_vm._v(" -\n  "+_vm._s(_vm.job.type?.label)+" -\n  "),(_vm.job.vehicle?.registration)?[_vm._v(_vm._s(_vm.job.vehicle?.registration.toUpperCase())+" - ")]:_vm._e(),_vm._v(_vm._s(_vm.job.location)+" - "+_vm._s(_vm._f("date")(_vm.job.date))+"\n")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }